import { useLanding } from "@/context/LandingContext";
import { InteractiveSection, MotionBg } from "./MotionBg";

export function CredibilityStrip() {
  const { t } = useLanding();
  return (
    <InteractiveSection as="div" className="credibility-strip" data-testid="credibility-strip">
      <MotionBg variant="shimmer" />
      <div className="container credibility-inner">
        {t.credibility.map((item) => (
          <div className="credibility-item" key={item.icon}>
            <span className="credibility-icon">{item.icon}</span>
            <span>{item.text}</span>
          </div>
        ))}
      </div>
    </InteractiveSection>
  );
}

export function Marquee() {
  const { t } = useLanding();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="marquee-band" aria-hidden="true" data-testid="topic-marquee">
      <div className="marquee-track">
        {items.map((item, index) => (
          <span className="marquee-item" key={`${item}-${index}`}>{item}</span>
        ))}
      </div>
    </div>
  );
}
